import React from "react";
import PollViewer from "../viewer/poll-viewer";
const Poll = ({
  settings,
  componentData,
  node,
  updateAttributes,
  selected
}) => {
  const block = { getKey: () => node.attrs.id };
  const helpers = { handleFileUpload: settings.handleFileUpload };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PollViewer,
    {
      componentData,
      settings,
      updateAttributes,
      block,
      selected,
      helpers
    }
  ));
};
export {
  Poll
};
//# sourceMappingURL=component.js.map
